import { useNavigation } from '@react-navigation/native';
import ParkingContext from 'context/ParkingContext';
import useReadPurchasedPrepaidTickets from 'hooks/useReadPurchasedPrepaidTickets';
import useSelectedParkingVehicle from 'hooks/useSelectedParkingVehicle';
import { useContext } from 'react';
import { View, ViewProps } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { ParkzonePmcUnion } from 'types/common';
import { PredefinedTicket } from 'types/generatedSchemaTypes';
import { ParkNavProps } from 'types/navigation';
import PrepaidTicketOrPermitItem from '../detail/PrepaidTicketOrPermitItem';

const PrepaidInfoBox: React.FC<ViewProps> = ({ ...props }) => {
  const { parkingZoneResult, setSelectedParkzonePmcUnion } =
    useContext(ParkingContext);
  const { selectedParkingVehiclePlate } = useParkingStore((state) => state);

  const selectedVehicle = useSelectedParkingVehicle(
    false,
    undefined,
    selectedParkingVehiclePlate
  );
  const { countryCode, uid = '' } = parkingZoneResult?.data?.parkZone || {};

  const { navigate: navigatePark } = useNavigation<ParkNavProps>();

  const { hasPrepaidForSelectedVehicle } = useReadPurchasedPrepaidTickets({
    selectedVehicle: selectedVehicle,
  });

  const onPrepaidItemSelect = (prepaidTicket: PredefinedTicket) => {
    setSelectedParkzonePmcUnion(prepaidTicket);
    navigatePark('parkPrepaidTicketsAndPermitsEdit', {
      parkingZoneUid: uid,
      id: prepaidTicket.uid || '',
    });
  };

  return (
    <View {...props}>
      {hasPrepaidForSelectedVehicle?.map(
        (item: ParkzonePmcUnion, index: number) => (
          <ColumnWithMargins key={`prepaid-owned-ticket-${item}`} mt={0} mb={8}>
            <PrepaidTicketOrPermitItem
              testID={`prepaid-owned-ticket-${index}`}
              item={item}
              countryCode={countryCode || 'SE'}
              onPress={onPrepaidItemSelect}
            />
          </ColumnWithMargins>
        )
      )}
    </View>
  );
};

export default PrepaidInfoBox;
